import { Container, StyledReminder, StyledReminderContainer, StyledText, StyledLink, StyledGains } from "./_setWithdrawValue";
import UseAuth from 'hooks/UseAuth';
import { useHistory } from 'react-router-dom';
import { useEffect, useState } from "react";
import api from "services/api"
import { toast } from "react-toastify";
import { parseCurrencyInCents } from "utils/format";


interface ISetWithdrawValueProps {
  onValueChange: (value: string) => void;
  value: string;
  gains: string;
  toReceive: string;
}

export const SetWithdrawValue = ({
  onValueChange,
  value,
}: ISetWithdrawValueProps) => {
  const { user } = UseAuth();
  const history = useHistory();
  const [gains, setGains] = useState<string>();
  const [toReceive, setToReceive] = useState<string>();

  const handleSupportClick = () => {
    if (user) {
      history.push('/suporte');
    }
  };

  const ensureGains = async () => {
    try {
      const response: any = await api.get('/providers/balance')

      const amount = parseCurrencyInCents(response?.data?.balance?.available?.amount || '0')

      setGains(amount);
      setToReceive(parseCurrencyInCents(response?.data?.balance?.waiting_funds?.amount) || '0');
    } catch (error: any) {
      toast.error(error?.response?.data?.error || 'Opps algo deu errado, tente novamente mais tarde!')
    }
  }

  useEffect(() => {
    ensureGains()
  }, [])

  return (
    <>
      <div>
        <Container>
          <h2 className="set-withdraw-value__subtitle">
            Quanto você deseja sacar?
          </h2>
          <div className="set-withdraw-value__prefix-input-container">
            <span className="set-withdraw-value__currency-prefix">R$</span>
            <input
              value={value}
              onChange={(e) => {
                onValueChange(e.target.value);
              }}
              type="number"
              min="0"
              max={gains}
              step="0.01"
              required
              className="set-withdraw-value__input"
            />
          </div>
          <StyledGains>
          <span>Seu saldo atual é: {gains}</span>
          </StyledGains>
        </Container>
        <StyledReminderContainer>
          <StyledReminder className="set-withdraw-value__reminder">
          Lembre-se! O valor mínimo para saque é de R$10,00. Para cada saque é cobrada uma taxa bancária de R$3,67.
          </StyledReminder>
          <StyledText>
            Precisa de ajuda? Entre em contato com o nosso{' '}
            <StyledLink onClick={handleSupportClick}>
              <span>Suporte</span>
            </StyledLink>.
          </StyledText>
        </StyledReminderContainer>
      </div>
    </>
  );
}